import { useLanguageStore } from "../stores/useLanguageStore";
import { t } from "./translations";

export const translateNow = (key, params) =>
  t(useLanguageStore.getState().language, key, params);
